import { apiFetch } from "./api";

// --- log throttling (module scope, no logic changes) ---
let __lastPollStartLogTs = 0;
let __lastPollResultLogTs = 0;
const __POLL_LOG_EVERY_MS = 60000; // show at most every 5s when repeating
let __lastSeenArticleSig = null;  // "title|contentLen" to detect new article

export async function fetchLatestWebfuseArticle() {
  // STEP 15 — poll start (throttled)
  {
    const now = performance.now();
    if (now - __lastPollStartLogTs > __POLL_LOG_EVERY_MS) {
      console.log('FLOW LOG:1️⃣5️⃣ App: poll start (fetchLatestWebfuseArticle)', {
        t: now.toFixed(1)
      });
      __lastPollStartLogTs = now;
    }
  }

  try {
    const sid = localStorage.getItem("newsCompare:currentSessionId") || "";
    const qp = sid ? `?session_id=${encodeURIComponent(sid)}` : "";
    const latest = await apiFetch(`/api/webfuse/latest${qp}`);

    const title = latest?.articleTitle || "";
    const contentLen = (latest?.articleContent || "").length;
    const hasArticle = !!(title && contentLen > 0);
    const sig = `${title}|${contentLen}`;
    const isNew = hasArticle && sig !== __lastSeenArticleSig;

    // STEP 16 — poll result (always log on NEW article; otherwise throttled)
    {
      const now = performance.now();
      if (isNew || (now - __lastPollResultLogTs > __POLL_LOG_EVERY_MS)) {
        console.log('FLOW LOG:1️⃣6️⃣ App: poll result (from Audit Log webhook)', {
          hasArticle,
          title,
          contentLen,
          isNew,
          t: now.toFixed(1)
        });
        __lastPollResultLogTs = now;
      }
      if (isNew) __lastSeenArticleSig = sig;
    }

    return latest;
  } catch (err) {
    console.warn('FLOW LOG:1️⃣6️⃣ App: poll error (from Audit Log webhook)', {
      error: String(err),
      t: performance.now().toFixed(1)
    });
    throw err;
  }
}
